module.exports = __webpack_public_path__ + "static/media/sn.c1a6798a.svg";